import React, { useState } from 'react';
import { Panel, PanelTheme, MultilineTextBox } from '@apply/components';

export const MultilineTextBoxDemo: React.FC = () => {
    // State for each example
    const [basicValue, setBasicValue] = useState('');
    const [readOnlyValue, setReadOnlyValue] = useState('Read only value');
    const [requiredValue, setRequiredValue] = useState('');

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Multiline Textbox</li>
            <br />
            <Panel theme={PanelTheme.White}>
                <div style={{ padding: '1rem' }}>
                    {/* Example 1: Basic Multiline Textbox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={basicValue}
                            onChange={setBasicValue}
                            label='Basic TextBox'
                        />
                    </div>

                    {/* Example 2: Read-Only Multiline Textbox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={readOnlyValue}
                            onChange={setReadOnlyValue}
                            label='Read-Only TextBox'
                            readOnly={true}
                        />
                    </div>

                    {/* Example 3: Required Field */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={requiredValue}
                            onChange={setRequiredValue}
                            label='Required TextBox'
                            required={true}
                        />
                    </div>
                </div>
            </Panel>
        </div>
    );
};
